import React from 'react'
import ModalItemSlider from './ModalItemSlider'
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import ContactBtn from './common/ContactBtn';
import { Card } from 'react-bootstrap';

const ModelLibrary = () => {
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
    <div className="d-flex justify-content-center align-content-center">
        <div className="max-width-set">
        <div className='px-2 mx-2 px-md-5 mx-md-5 '>
            <h1 className='top-title-0 text-center  py-1'>3D Library</h1>
            {/* <div className='text-center py-4'>
                <span className='text-content px-5'>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                </span>
            </div> */}
            <div className='content-title text-center py-4'>Your Custom Product Showcase: 3D Experiences Tailored to Your Brand</div>
            
        </div>
        </div>
        </div>
      

      <div className="d-flex justify-content-center">
        <div>
      <p className=' text-center top-title-3 max-width-set py-2 px-5'>Integrate 3D Players and Configurators seamlessly into any landing page or curate them as a collection in your own branded 3D Library. Elevate your digital presentations and captivate your audience.</p>
      
      {/* <p className=' text-center top-title-3 max-width-set py-2 px-5'><b>Call To Action -</b> Explore the Possibilities: Showcase a 3D Library of your Products. </p> */}

      </div>
        </div>
        <div className="d-flex justify-content-center">
      <div className=" d-flex justify-content-center flex-column  max-width-set ModelLibrary-video-player">
            <p className='top-title-2 max-width-set modelLibrary-top-title text-center themeColor fw-bold'>Explore the Possibilities: Start showcasing a 3D Library of your products.</p>
            <div className=" d-flex justify-content-center video-player-modelLibrary">
              <div className="info-img-modelLibrary">
                {/* <div className='videoplayer-modelLibrary' >
                    <img className='imageinside-modelLibrary' src="Image/image-modelLibary.png"/>
                    <button className='imageinside-modelLibary-play' onClick={() => setModalShow(true)}>
                    <img src="Image/playBtn.svg" height="40px"/>
                    </button>
                    
                </div> */}

                  {/* <video width="100%" loop={true} autoPlay="autoPlay" id="vid" muted playsInline>
                      <source src="video/gtie-modal-library.mp4" type="video/mp4" />
                  </video> */}
                  
                  <Card className="bg-transparent shadow-0 border-0 text-white">
                    <Card.Img src="Image/gtie-modal-library.jpeg" alt="Card image" className="container p-0 m-0" />
                    <Card.ImgOverlay className="p-0 m-0">
                      <video className='container p-0' loop={true} autoPlay preload='auto' muted playsInline>
                        <source src="video/gtie-modal-library.mp4" type="video/mp4" />
                      </video>
                    </Card.ImgOverlay>
                  </Card>

              <p className="text-inside-img-modelLibrary text-center ">
                Custom-Branded Libraries
              </p>
              </div>
            </div>
      </div>
      </div>
      <br />
      <br />
      <ContactBtn/>
    </>
  )
}

export default ModelLibrary;